import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const DashboardFilters = ({
  className = "",
  searchVariant = "stacked",
  showDates = true,
  showWard = true,
  showSearch = true,
  fromDate,
  toDate,
  ward,
  wards = [],
  onFromDateChange,
  onToDateChange,
  onWardChange,
  onSearch,
  showLabels = true,
}) => (
  <div className={`pd-filters ${className}`.trim()}>
    {showDates ? (
      <>
        <div className="pd-filter-field">
          {showLabels ? <label>From Date</label> : null}
          <input
            type="date"
            value={fromDate || ""}
            onChange={(e) => onFromDateChange?.(e.target.value)}
          />
        </div>
        <div className="pd-filter-field">
          {showLabels ? <label>To Date</label> : null}
          <input
            type="date"
            value={toDate || ""}
            onChange={(e) => onToDateChange?.(e.target.value)}
          />
        </div>
      </>
    ) : null}

    {showWard ? (
      <div className="pd-filter-field">
        {showLabels ? <label>Ward</label> : null}
        <select value={ward || ""} onChange={(e) => onWardChange?.(e.target.value)}>
          <option value="">All Ward</option>
          {wards.map((item) => (
            <option key={item.value ?? item.circleId} value={item.value ?? item.circleId}>
              {item.label ?? item.circleName}
            </option>
          ))}
        </select>
      </div>
    ) : null}

    {showSearch ? (
      <button
        type="button"
        className={`pd-search-btn${
          searchVariant === "inline" ? " pd-search-btn-inline" : ""
        }`}
        onClick={onSearch}
      >
        {searchVariant === "inline" ? (
          <>
            <FontAwesomeIcon icon={faSearch} />
            <span>SEARCH</span>
          </>
        ) : (
          <span>SEARCH</span>
        )}
      </button>
    ) : null}
  </div>
);

export default DashboardFilters;
